import { isNotDefined } from '@sgme/fp';
import { HStack } from '@sgme/ui';
import type { CustomCellRendererProps } from 'ag-grid-react';

import { OpenInXoneButton } from '@/App/Blotter/grids/OpenInXoneButton.tsx';
import type { BlotterAccumulatorEntry } from '@/store/blotter/types/BlotterAccumulatorEntry.ts';

export const CommandsCellRenderer = ({ data: entry }: CustomCellRendererProps<BlotterAccumulatorEntry, string>) => {
  if (isNotDefined(entry) || isNotDefined(entry.product)) {
    return null;
  }

  return (
    <HStack horizontalAlignment="start">
      <OpenInXoneButton entry={entry} entryType="accumulator" />
    </HStack>
  );
};
